import React from "react";
import "./spinner.scss";

export default function LoadingSpinner() {  return (
    <div className="spinner-container overlay" data-testid="spinner-container">
      <div className="loading-spinner ">
      <auro-loader ringworm lg></auro-loader>
      </div>
    </div>
  );
}